module.exports = __webpack_public_path__ + "img/OP CONTROLLER.ec00cdbf.png";